import { i18nConfig } from "#environment/i18nConfig"
import { ROUTE_LOCALIZATION_MAPPING } from "#environment/route-localization-mapping"
import { createLocalizationUtils as createClientLocalizationUtils } from "#modules/localization/pathNames/clientPathNameLocalization"

// TODO find a way to better initialize this client usable localization utils and the server only usable localization utils

const config = {
  locales: i18nConfig.locales,
  defaultLocale: i18nConfig.defaultLocale,
  keepDefaultLocale: false,
  routeLocalizationMapping: ROUTE_LOCALIZATION_MAPPING,
  baseUrl: process.env.NEXT_PUBLIC_URL!,
}

export const { Link, localizePath } = createClientLocalizationUtils(config)
